import { alpha, Box, Button, Container, Grid, Typography, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import LogoCard from '../LogoCard';
import policeCar from '../../assets/policeCar.png';
import { COPY } from '../../constants';
import { useUser } from '../../hooks/useUser';
import PrimaryButton from '../buttons/PrimaryButton';
import { useLogout } from '../../hooks/useLogout';

const NotFoundFallback = () => {
  const { user } = useUser();
  const theme = useTheme();
  const handleLogout = useLogout();

  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const clearBlue = alpha(theme.palette.info.light, 0.1);

  const isActiveAdmin =
    user?.profile.status === 'active' && user.profile.role.name === 'Super Admin';

  return (
    <Box
      component={'main'}
      sx={{
        gridArea: 'main',
        backgroundColor: clearBlue
      }}>
      <Container
        sx={{
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <LogoCard>
          <Grid
            size={12}
            sx={{
              gap: 2,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
            <Typography variant="h5" sx={{ paddingTop: 4, paddingBottom: 1 }}>
              {COPY.notFound.header}
            </Typography>
            <Typography variant="body1" align="center" sx={{ paddingX: 4 }}>
              {isActiveAdmin ? COPY.notFound.explanation : COPY.notFound.nonAdminExplanation}
            </Typography>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <Button
                onClick={handleGoBack}
                color="primary"
                variant="contained"
                disableElevation
                sx={{ borderRadius: 2, margin: 3, fontSize: '10pt' }}
              >
                {COPY.notFound.button1}
              </Button>
              <PrimaryButton disabled={false} loading={false} action={handleLogout}>
                {COPY.notFound.button2}
              </PrimaryButton>
            </Box>
            <Box
              component="img"
              src={policeCar}
              alt="A sports police car with officers in the background. The car is overly fancy."
              sx={{
                maxWidth: '90%',
                borderRadius: 3
              }}
            />
            <Typography variant="body1" align="center" sx={{ paddingX: 4, paddingBottom: 4 }}>
              {COPY.notFound.tag}
            </Typography>
          </Grid>
        </LogoCard>
        <Typography
          variant="caption"
          sx={{
            paddingY: 1,
            color: theme.palette.grey[600]
          }}>
          {COPY.copyrightFooter}
        </Typography>
      </Container>
    </Box>
  );
};

export default NotFoundFallback;
